import { ItemRow } from '../../../../../../ItemRow/ItemRow';
import { BridgeFundedField } from './components/BridgeFundedField';
import { SameAsCommittedField } from './components/SameAsCommittedField';

/** Bridge Funded and Same as Committed on one row. */
export const BridgeFundedInfo = () => {
    return (
        <ItemRow>
            <BridgeFundedField />
            <SameAsCommittedField />
        </ItemRow>
    );
};
